export const DefaultAvailability = {
  sun: { startTime: 0, endTime: 0 },
  mon: { startTime: 900, endTime: 1700 },
  tue: { startTime: 900, endTime: 1700 },
  wed: { startTime: 900, endTime: 1700 },
  thu: { startTime: 900, endTime: 1700 },
  fri: { startTime: 900, endTime: 1700 },
  sat: { startTime: 0, endTime: 0 },
}

export const DefaultRecurringAvailability = {
  name: 'recurringAvailability',
  // label: OnSchedUtils.Internationalize(element, `consumer_availability_weekday_${day}`),
  label: 'Weekly Recurring Hours',
  detail: 'Quickly enable or disable weekly recurring hours.',
  required: false,
  type: 'checkbox',
  defaultChecked: true
}
